import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Set initial state - first tab is active by default
    this.showFirstTab()
  }

  showFirstTab() {
    if (this.tabTargets.length > 0) {
      const firstTab = this.tabTargets[0]
      const tabName = firstTab.dataset.tab
      this.activateTab(tabName)
    }
  }

  select(event) {
    const tabName = event.currentTarget.dataset.tab
    this.activateTab(tabName)
  }

  activateTab(tabName) {
    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.remove("text-beige-300", "hover:text-white", "hover:bg-beige-700/50")
        tab.classList.add("text-white", "bg-beige-700")
        // Update badge style
        const badge = tab.querySelector("span.rounded-full")
        if (badge) {
          badge.classList.remove("bg-beige-600/50", "text-beige-300")
          badge.classList.add("bg-beige-600", "text-white")
        }
      } else {
        tab.classList.remove("text-white", "bg-beige-700")
        tab.classList.add("text-beige-300", "hover:text-white", "hover:bg-beige-700/50")
        // Update badge style
        const badge = tab.querySelector("span.rounded-full")
        if (badge) {
          badge.classList.remove("bg-beige-600", "text-white")
          badge.classList.add("bg-beige-600/50", "text-beige-300")
        }
      }
    })

    // Update panel visibility
    this.panelTargets.forEach(panel => {
      if (panel.dataset.panel === tabName) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
